import { render, staticRenderFns } from "./ChatTodo.vue?vue&type=template&id=01efeb9a&scoped=true"
import script from "./ChatTodo.vue?vue&type=script&lang=js"
export * from "./ChatTodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01efeb9a",
  null
  
)

export default component.exports